module.exports = __webpack_public_path__ + "static/media/logging.65bb76a9.svg";